import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { CountryGroupService } from '../../../api/countrygroup/countrygroup.service';
import { CountryGroupModel } from '../../../api/countrygroup/countrygroup';
import { CountryModel } from '../../../api/country/country';
import { SelectCountry } from '../../../api/countrygroup/sCmbCountry';
import { MasterDataConstant } from '../../../api/masterdata.constant';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'countrygroup-page',
    templateUrl: './countrygroup.html'
})
export class CountryGroupComponent implements OnInit {
    cmbCountry: CountryModel[];
    cmbBindCountry: CountryModel[];
    selectCountry: SelectCountry;
    sCountry = [];
    aCountry = [];
    countriesGroup: CountryGroupModel[];
    countryGroup: CountryGroupModel;
    cougroupname: string;
    currency_code: string;
    tIndex: number;
    message: string;
    cgUserActive: boolean;
    constructor(
        private masterdataservice : MasterDataConstant,
        private countrygroupservice: CountryGroupService,
        private router: Router
        ) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN')) {
            this.initCountryGroupList();
        } else {
            this.router.navigate(['/']);
        }
    }
    initCountryGroupList() {
        this.countrygroupservice
            .allCountygroup()
            .then(data => this.countriesGroup = data);
        this.countrygroupservice
            .allCountryList()
            .then(data => {
                this.cmbCountry = data
            });
    }
    showModal() {
        this.cancelAction();
        this.cmbBindCountry = this.cmbCountry;
        $(function () {
            $('#country').select2({
                dropdownParent: $('#example3'),
                placeholder: 'Multi Country'
            });
        })
    }
    submitCountryGroup() {
        var country = $('#country').val();
        if (this.cougroupname == undefined || this.cougroupname == "") {
            $.notify({
                message: "Please Enter Country Group Name."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (country == undefined || country == "") {
            $.notify({
                message: "Please Select Atleast One Country."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        var iCountryGroup = {
            name: this.cougroupname,
            countryId: country.toString()
        }
        this.countrygroupservice
            .iCountygroup(iCountryGroup)
            .then(data => {
                if (data.status) {
                    var jdata = {
                        key: 'countrygroup'
                    }
                    this.countriesGroup.push(data.data);
                            $.notify({
                                message: data.message
                            }, {
                                type: 'success',
                                placement: {
                                    from: 'bottom',
                                    align: 'left'
                                },
                                delay: 100,
                                timer: 100
                            });
                            this.cancelAction();
                            $(function () {
                                $('#example3').modal('toggle');
                            });
                            this.masterdataservice.CountryGroupList = [];
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    cancelAction() {
        this.cougroupname = ""
        this.currency_code = ""
    }
    showCountryGroup(countriesgroup, i) {
        $(function () {
            $('#ucountry').select2({
                dropdownParent: $('#exampleModal'),
                placeholder: 'Multi Country'
            });
        })
        this.cmbBindCountry = this.cmbCountry;
        this.tIndex = i;
        this.countryGroup = countriesgroup;
        this.cougroupname = countriesgroup.name;
        var cmbSelectedBindCountry = [];
        var idsplitted = countriesgroup.countryid.split(',');
        var namesplitted = countriesgroup.countrynameList.split(',');
        for (var _i = 0; _i < idsplitted.length; _i++) {
            var jsonData = {
                id: idsplitted[_i],
                name: namesplitted[_i]
            }
            cmbSelectedBindCountry.push(jsonData);
        }
        this.sCountry = cmbSelectedBindCountry;
    }
    updateCountryGroup() {
        var country = $('#ucountry').val();
        if (this.cougroupname == undefined || this.cougroupname == "") {
            $.notify({
                message: "Please Enter Country Group Name."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (country == undefined || country == "") {
            $.notify({
                message: "Please Select Atleast One Country."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        var uCountryGroup =
        {
            countryId: country.toString()
        }
        this.countrygroupservice
            .uCountygroup(this.countryGroup.id, uCountryGroup)
            .then(data => {
                if (data.status) {
                    var jdata = {
                        key: 'countrygroup'
                    }
                    this.countrygroupservice
                                .allCountygroup()
                                .then(data => this.countriesGroup = data);
                            $.notify({
                                message: data.message
                            }, {
                                type: 'success',
                                placement: {
                                    from: 'bottom',
                                    align: 'left'
                                },
                                delay: 100,
                                timer: 100
                            });
                            $(function () {
                                $('#exampleModal').modal('toggle');
                            });
                            this.masterdataservice.CountryGroupList = [];
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    onlyNumberKey(event) {
        return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    deactiveCountryGroup(id, i, country) {
        if (country.isactive == true) {
            country.isactive = false;
        }
        else {
            country.isactive = true;
        }
        var cAdmin = {
            isactive: country.isactive
        }
        this.countrygroupservice
            .dCountryGroup(id, cAdmin)
            .then(data => {
                if (data.status == true) {
                    this.message = data.message
                    $.notify({
                        message: this.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    this.masterdataservice.CountryGroupList = [];
                } else {
                    this.message = data.message
                    $.notify({
                        message: this.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/countrygroup/countrygroup.page.ts